import type {
  ListSamplingPoliciesResponse,
  PutSamplingPoliciesRequest,
  PutSamplingPoliciesResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/** Standard sampling policies (#2862): one table for trace + lifecycle sampling. */
const PATH = '/v1/ops/sampling-policies';

export async function getSamplingPolicies(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListSamplingPoliciesResponse> {
  return opsApiRequest<ListSamplingPoliciesResponse>(PATH, { signal }, fetchImpl);
}

/**
 * Full replace; a stale `expected_version` is a 409, a closed CN downlink
 * write gate is a 403 `cn_downlink_not_ready:`, and nothing is written.
 * `dry_run: true` runs every check and returns the warnings without writing.
 */
export async function putSamplingPolicies(
  body: PutSamplingPoliciesRequest,
  fetchImpl: typeof fetch,
): Promise<PutSamplingPoliciesResponse> {
  return opsApiRequest<PutSamplingPoliciesResponse>(PATH, { method: 'PUT', body }, fetchImpl);
}
